module.exports = __webpack_public_path__ + "img/ercode.2ea2fbe6.jpg";